'use client'

import { isEmbedPath } from '@/lib/react-native/services/react-native.routing'
import { PaginationSkeleton } from '@/ui/layouts/pagination/_components/PaginationSkeleton'
import { useAtom } from 'jotai'
import { usePathname } from 'next/navigation'
import { useEffect } from 'react'
import { isProductListPageLoadingAtom } from '../../services/productList.store'
import { ProductListSkeleton } from './ProductListSkeleton'

type ProductListClientWrapperProps = React.PropsWithChildren

export function ProductListClientWrapper({
  children,
}: ProductListClientWrapperProps): React.ReactNode {
  const pathname = usePathname()
  const [isPageLoading, setIsPageLoading] = useAtom(isProductListPageLoadingAtom)
  const isEmbed = isEmbedPath(pathname)

  useEffect(() => {
    setIsPageLoading(false)
  }, [pathname, setIsPageLoading])

  if (!isPageLoading) {
    return children
  }

  return (
    <>
      <ProductListSkeleton />
      {!isEmbed && <PaginationSkeleton />}
    </>
  )
}
